import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown,
} from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import OutboundLoadHelpers from '../../../helpers/outboundLoad';
import OutboundOrderHelpers from '../../../helpers/outboundOrder';
import {
  getOutboundLoads, getOutboundLoad, getLoadOrders, toggleLoadPriority, linkDock, verifyDockControl, unlinkDock,
  cancelOutboundLoad, changeDock,
} from '../../../app/store/actions/outboundLoads';
import {
  finalizeCheckVolumes,
} from '../../../app/store/actions/dockControl';
import { printConsolidationsLabel } from '../../../app/store/actions/labels';
import { getUserPrinterOptions } from '../../../app/store/actions/printers';
import LoadLinkDockModal from './modalLinkDock';
import {
  cancelOutboundOrder,
} from '../../../app/store/actions/outboundOrders';
import addNotification from '../../../components/notification';
import Table from '../../../components/table/Table';
import ROUTES from '../../../config/routes';
import UserConfirmationModal from '../../../components/pages/userConfirmationModal';

class OutboundLoadMonitor extends React.Component {
  constructor(props) {
    super(props);

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE41' /* Expedição */) },
      { value: I18n.t('BEE4523' /* Monitor de Carga */), active: true },
    ];

    this.state = {
      startDate: moment().subtract(30, 'd'),
      endDate: moment(),
      outboundLoads: [],
      loadOrders: [],
      selectedLoad: {},
      selectedOrder: {},
      showLinkDockModal: false,
      showModalUrgent: false,
      showRemoveUrgent: false,
      outboundLoadUrgent: null,
      showRemoveLinkedDockModal: false,
      showVerifyDockControl: false,
      selectedDock: null,
      showWarningFinalizeCheckVolumes: false,
      showPrintConsolidationDialog: false,
      showPrinterDialog: false,
      printerOptions: [],
      printerSelected: null,
      showCancelOrderModal: false,
      showCancelLoadModal: false,
      cancelType: '',
      showUserModal: false,
    };

    this.defaultSortedOrders = [{
      id: 'orderNumber',
      desc: false,
    }];
    this.defaultSorted = [{
      id: 'loadNumber',
      desc: false,
    }];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            {(
              <UncontrolledButtonDropdown>
                <DropdownToggle color="default" caret className="btn-xs" />
                <DropdownMenu>
                  {(rows.original.status < 5 && (!rows.original.urgent ? (
                    <DropdownItem onClick={() => this.showUrgentModal(rows.original.id)}>
                      {I18n.t('BEE613' /* Urgente */)}
                    </DropdownItem>
                  ) : (
                    <DropdownItem onClick={() => this.showModalRemoveUrgent(rows.original.id)}>
                      {I18n.t('BEE2637' /* Remover Urgência */)}
                    </DropdownItem>
                  )))}
                  {(rows.original.status === 1 && (
                    <DropdownItem onClick={() => this.showLinkDockModal()}>
                      {I18n.t('BEE4527' /* Atribuir Doca */)}
                    </DropdownItem>
                  ))}
                  {(rows.original.status === 3 && !rows.original.hasCheckedProduct && (
                    <DropdownItem onClick={() => this.showLinkDockModal()}>
                      {I18n.t('BEE4646' /* Alterar Doca */)}
                    </DropdownItem>
                  ))}
                  {(rows.original.status === 2 && (
                    <DropdownItem onClick={() => this.showRemoveLinkedDockModal()}>
                      {I18n.t('BEE4530' /* Remover Doca */)}
                    </DropdownItem>
                  ))}
                  {rows.original.status === 5 && rows.original.dockControlId && (
                    <DropdownItem
                      onClick={() => this.setState({
                        showWarningFinalizeCheckVolumes: true,
                        selectedLoad: rows.original,
                      })}
                    >
                      {I18n.t('BEE4548' /* Finalizar Doca */)}
                    </DropdownItem>
                  )}
                  {(rows.original.status <= 2 && (
                    <DropdownItem onClick={() => this.showCancelLoad(rows.original)}>
                      {I18n.t('BEE4555' /* Cancelar Carga */)}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            )}
          </div>
        ),
      },
      {
        Header: I18n.t('BEE4524' /* Número de Carga */),
        accessor: 'loadNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE578' /* Data Criação */),
        accessor: 'createdAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Filter: this.filterColumn,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
          return false;
        },
        Cell: (row) => (
          <span>
            {row.value ? moment(row.value).format('DD/MM/YYYY') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE199' /* Doca */),
        accessor: 'dockName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE301' /* Transportadora */),
        accessor: 'carrierName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'status',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <span>{OutboundLoadHelpers.statusOutboundLoad(row.value)}</span>
          </div>
        ),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {OutboundLoadHelpers.statusOutboundLoad().map((element) => (
              <option
                key={element.value}
                value={element.value}
              >
                {element.label}
              </option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE613' /* Urgente */),
        accessor: 'urgent',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            {rows.original.urgent ? I18n.t('BEE172' /* Sim */) : I18n.t('BEE173' /* Não */)}
          </div>
        ),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            <option value>{I18n.t('BEE172' /* Sim */)}</option>
            <option value={false}>{I18n.t('BEE173' /* Não */)}</option>
          </select>
        ),
      }, {
        Header: I18n.t('BEE54' /* Progresso */),
        accessor: 'progress',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4535' /* Documentos Vinculados */),
        accessor: 'linkedOrders',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2103' /* Volumes Consolidados */),
        accessor: 'consolidatedVolumes',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Filter: this.filterColumn,
      },
    ];

    this.tableOrderColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => {
          const showCancel = !!(rows.original.status < 4 && !rows.original.pickStartAt);

          return (
            <div style={{ textAlign: 'center' }}>
              <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
              {(
                <UncontrolledButtonDropdown>
                  <DropdownToggle color="default" caret className="btn-xs" />
                  <DropdownMenu>
                    <DropdownItem onClick={() => this.showOutboundOrderDetail(rows)}>
                      {I18n.t('BEE56' /* Detalhes */)}
                    </DropdownItem>
                    {showCancel && (
                      <DropdownItem onClick={() => this.showCancelOrder(rows.original)}>
                        {I18n.t('BEE99' /* Cancelar */)}
                      </DropdownItem>
                    )}
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              )}
            </div>
          );
        },
      },
      {
        Header: I18n.t('BEE443' /* Documento */),
        accessor: 'orderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE50' /* Cliente */),
        accessor: 'customerName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE200' /* Tipo */),
        accessor: 'orderType',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE402' /* Nota Fiscal */),
        accessor: 'invoiceNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'status',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <span>{OutboundOrderHelpers.outboundOrderStatus(row.value)}</span>
          </div>
        ),
        filterMethod: (filter, row) => {
          if (parseInt(filter.value, 10) === parseInt(row.status, 10)) {
            return true;
          }
          return false;
        },
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {OutboundOrderHelpers.outboundOrderStatus().map((elem, index) => (
              <option value={elem.value} key={elem.value}>{elem.label}</option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE301' /* Transportadora */),
        accessor: 'carrierName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
        Filter: this.filterColumn,
      },
    ];
  }

  async componentDidMount() {
    this.getOutboundLoads();

    const { printerSelected } = this.state;

    const printerReq = await this.props.getUserPrinterOptions();
    const { printerOptions, userPrinter } = printerReq;

    this.setState({
      printerOptions,
      printerSelected: (printerSelected !== null && printerSelected !== userPrinter)
        ? printerSelected
        : userPrinter,
    });
  }

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  filterColumn = ({ filter, onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  showOutboundOrderDetail = (outboundOrder) => {
    this.props.history.push({
      pathname: ROUTES.CONSULT_OUTBOUND_ORDER_DETAIL,
      state: {
        outboundOrder: outboundOrder.original,
        loadMonitor: true,
      },
    });
  };

  showUrgentModal = (outboundLoadId) => {
    this.setState({
      showModalUrgent: true,
      outboundLoadUrgent: outboundLoadId,
    });
  };

  closeUrgentModal = () => {
    this.setState({
      showModalUrgent: false,
      showRemoveUrgent: false,
      outboundLoadUrgent: null,
    });
  };

  showModalRemoveUrgent = async (outboundLoadId) => {
    this.setState({
      showRemoveUrgent: true,
      outboundLoadUrgent: outboundLoadId,
    });
  };

  showLinkDockModal = () => {
    this.setState({
      showLinkDockModal: true,
    });
  };

  // BEES-3943 - fechar o modal (Voltar / X) nao recarrega a lista; quem altera
  // a carga chama refreshOutboundLoad.
  closeLinkDockModal = () => {
    this.setState({
      showLinkDockModal: false,
      showVerifyDockControl: false,
    });
  };

  showRemoveLinkedDockModal = () => {
    this.setState({
      showRemoveLinkedDockModal: true,
    });
  };

  closeRemoveLinkedDockModal = () => {
    this.setState({
      showRemoveLinkedDockModal: false,
    });
  };

  handleDateApplyEvent = async (event) => {
    await this.setState({
      startDate: event[0],
      endDate: event[1],
    });

    this.getOutboundLoads();
  };

  getOutboundLoads = async () => {
    const startDate = moment(this.state.startDate).format();
    const endDate = moment(this.state.endDate).format();

    try {
      const outboundLoads = await this.props.getOutboundLoads(
        startDate,
        endDate,
      );

      if (outboundLoads && outboundLoads.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE4523' /* Monitor de Carga */),
          I18n.t('BEE4525' /* Nenhuma carga foi encontrada */),

          'top-right',
        );
      } else {
        this.setState({ outboundLoads });
      }
    } catch (error) {
      const messageError = error.response && error.response.data
        && error.response.data.error && error.response.data.error.message;

      if (messageError) addNotification('danger', I18n.t('BEE4523' /* Monitor de Carga */), messageError, 'top-right');
      else {
        addNotification(
          'danger',
          I18n.t('BEE4523' /* Monitor de Carga */),
          I18n.t('BEE4525' /* Nenhuma carga foi encontrada */),
          'top-right',
        );
      }
    }
  };

  // BEES-3943 - atualiza apenas a carga afetada (e seus documentos, quando e a
  // carga selecionada) em vez de recarregar toda a lista. Se a carga nao vier
  // (ex.: saiu do periodo), recarrega a lista como antes.
  refreshOutboundLoad = async (outboundLoadId) => {
    try {
      const outboundLoad = await this.props.getOutboundLoad(outboundLoadId);

      if (!outboundLoad || outboundLoad.success === false || !outboundLoad.id) {
        this.getOutboundLoads();
        return;
      }

      const { selectedLoad } = this.state;
      const isSelected = !!selectedLoad && selectedLoad.id === outboundLoad.id;

      this.setState((prevState) => ({
        outboundLoads: prevState.outboundLoads.map((load) => (
          load.id === outboundLoad.id ? outboundLoad : load
        )),
        selectedLoad: isSelected ? outboundLoad : prevState.selectedLoad,
      }), () => {
        if (isSelected) this.getLoadOrders();
      });
    } catch (error) {
      this.getOutboundLoads();
    }
  };

  getLoadOrders = async () => {
    const { selectedLoad } = this.state;

    try {
      const loadOrders = await this.props.getLoadOrders(selectedLoad.id);

      this.setState({ loadOrders });
    } catch (error) {
      const messageError = error.response && error.response.data
        && error.response.data.error && error.response.data.error.message;

      if (messageError) addNotification('danger', I18n.t('BEE4523' /* Monitor de Carga */), messageError, 'top-right');
      else {
        addNotification(
          'danger',
          I18n.t('BEE4523' /* Monitor de Carga */),
          I18n.t('BEE4554' /* Nenhum documento nessa carga */),
          'top-right',
        );
      }
    }
  };

  modifyUrgency = async (isUrgent) => {
    const { outboundLoadUrgent } = this.state;

    if (outboundLoadUrgent) {
      try {
        const result = await this.props.toggleLoadPriority(outboundLoadUrgent, isUrgent);

        if (result && result.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE4523' /* Monitor de Carga */),
            I18n.t('BEE1960' /* Erro ao gravar os dados */),
            'top-right',
          );
        } else {
          addNotification(
            'success',
            I18n.t('BEE4523' /* Monitor de Carga */),
            (isUrgent)
              ? I18n.t('BEE2635' /* Documento alterado para Urgente com sucesso! */)
              : I18n.t('BEE2636' /* Urgencia removida com sucesso! */),
            'top-right',
          );

          this.refreshOutboundLoad(outboundLoadUrgent);
        }
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error;

        if (error && error.message) {
          const messageError = (error.details)
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;
          addNotification('danger', I18n.t('BEE4523' /* Monitor de Carga */), messageError, 'top-right');
        } else {
          addNotification(
            'danger',
            I18n.t('BEE4523' /* Monitor de Carga */),
            I18n.t('BEE1960' /* Erro ao gravar os dados */),
            'top-right',
          );
        }
      }
    }

    this.closeUrgentModal();
  };

  verifyDockControl = async (dockCode) => {
    const { selectedLoad } = this.state;

    const data = await this.props.verifyDockControl(selectedLoad.id, dockCode);

    if (data.id) {
      this.setState({
        showVerifyDockControl: true,
        selectedDock: dockCode,
      });
    } else if (selectedLoad.status === 3) {
      this.changeDock(dockCode);
    } else {
      this.linkDock(dockCode);
    }
  };

  linkDock = async (dockCode) => {
    const { selectedLoad } = this.state;

    try {
      await this.props.linkDock(selectedLoad.id, dockCode);
      this.closeLinkDockModal();

      addNotification(
        'success',
        I18n.t('BEE4533' /* Vincular Doca */),
        I18n.t('BEE4534' /* Doca vinculada com sucesso. */),
        'top-right',
      );

      this.refreshOutboundLoad(selectedLoad.id);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE4533' /* Vincular Doca */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE4533' /* Vincular Doca */),
            I18n.t('BEE1156' /* Erro ao vincular doca! */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4533' /* Vincular Doca */),
          I18n.t('BEE1156' /* Erro ao vincular doca! */),
          'top-right',
        );
      }
    }
  };

  unlinkDock = async () => {
    const { selectedLoad } = this.state;

    if (selectedLoad) {
      try {
        const result = await this.props.unlinkDock(selectedLoad.id);

        if (result && result.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE4523' /* Monitor de Carga */),
            I18n.t('BEE1960' /* Erro ao gravar os dados */),
            'top-right',
          );
        } else {
          addNotification(
            'success',
            I18n.t('BEE4523' /* Monitor de Carga */),
            I18n.t('BEE4544' /* Doca removida com sucesso! */),
            'top-right',
          );

          this.refreshOutboundLoad(selectedLoad.id);
        }
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error;

        if (error && error.message) {
          const messageError = (error.details)
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;
          addNotification('danger', I18n.t('BEE4523' /* Monitor de Carga */), messageError, 'top-right');
        } else {
          addNotification(
            'danger',
            I18n.t('BEE4523' /* Monitor de Carga */),
            I18n.t('BEE1960' /* Erro ao gravar os dados */),
            'top-right',
          );
        }
      }
    }

    this.closeRemoveLinkedDockModal();
  };

  changeDock = async (dockCode) => {
    const { selectedLoad } = this.state;

    try {
      await this.props.changeDock(selectedLoad.id, dockCode);
      this.closeLinkDockModal();

      addNotification(
        'success',
        I18n.t('BEE4646' /* Alterar Doca */),
        I18n.t('BEE4534' /* Doca vinculada com sucesso. */),
        'top-right',
      );

      this.refreshOutboundLoad(selectedLoad.id);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE4646' /* Alterar Doca */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE4646' /* Alterar Doca */),
            I18n.t('BEE1156' /* Erro ao vincular doca! */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4646' /* Alterar Doca */),
          I18n.t('BEE1156' /* Erro ao vincular doca! */),
          'top-right',
        );
      }

      this.closeLinkDockModal();
    }
  };

  finalizeCheckVolumes = async () => {
    const { userLogged } = this.props;
    const { selectedLoad } = this.state;

    const dockControlId = selectedLoad
      ? (selectedLoad.dockControlId
        || (selectedLoad.dockControl && selectedLoad.dockControl.id))
      : null;

    if (!dockControlId) {
      addNotification(
        'danger',
        I18n.t('BEE19' /* Docas */),
        I18n.t('BEE1852' /* Não foi possível finalizar esta ação */),
        'top-right',
      );
      this.setState({ showWarningFinalizeCheckVolumes: false });
      return;
    }

    try {
      const result = await this.props.finalizeCheckVolumes(dockControlId);

      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE19' /* Docas */),
          result.message || I18n.t('BEE1852' /* Não foi possível finalizar esta ação */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE19' /* Docas */),
          I18n.t('BEE1766' /* Finalizado */),
          'top-right',
        );

        if (result.waybillNumber) {
          addNotification(
            'success',
            I18n.t('BEE19' /* Docas */),
            I18n.t('BEE3372', { 0: result.waybillNumber } /* Romaneio %{0} gerado com sucesso! */),
            'top-right',
          );
        }

        const dockPrintConsolidation = userLogged.mainBranchData
          ? userLogged.mainBranchData.dockPrintConsolidation
          : false;

        if (dockPrintConsolidation) {
          this.setState({ showPrintConsolidationDialog: true });
        } else {
          this.setState({
            showWarningFinalizeCheckVolumes: false,
            showPrinterDialog: false,
            showPrintConsolidationDialog: false,
          });
        }
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        addNotification('danger', I18n.t('BEE19' /* Docas */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE19' /* Docas */),
          I18n.t('BEE1852' /* Não foi possível finalizar esta ação */),
          'top-right',
        );
      }
    }

    this.getOutboundLoads();
    this.setState({ showWarningFinalizeCheckVolumes: false });
  };

  onDoPrintConsolidation = async () => {
    const { printerOptions } = this.state;

    if (!printerOptions || printerOptions.length === 0) {
      addNotification(
        'danger',
        I18n.t('BEE19' /* Docas */),
        I18n.t('BEE1415' /* Usuário não possui impressora relacionada */),
        'top-right',
      );

      this.setState({
        showWarningFinalizeCheckVolumes: false,
        showPrinterDialog: false,
        showPrintConsolidationDialog: false,
      });
      return;
    }

    if (printerOptions && printerOptions.length > 1) {
      this.setState({
        showPrintConsolidationDialog: false,
        showPrinterDialog: true,
      });
    } else {
      await this.setState({
        showPrintConsolidationDialog: false,
        showPrinterDialog: false,
        printerSelected: printerOptions[0].value,
      });

      await this.onSelectFilterModal();
    }
  };

  onSelectFilterModal = () => {
    const { printerSelected, loadOrders } = this.state;

    this.setState({ showPrinterDialog: false });

    const outboundOrderId = [];

    loadOrders.forEach((element) => {
      outboundOrderId.push(element.id);
    });

    this.props.printConsolidationsLabel(printerSelected, outboundOrderId, false);

    addNotification(
      'success',
      I18n.t('BEE3375' /* Etiqueta de Consolidação */),
      I18n.t('BEE3228' /* Etiquetas enviadas para impressora! */),
      'top-right',
    );

    this.setState({
      showWarningFinalizeCheckVolumes: false,
      showPrinterDialog: false,
      showPrintConsolidationDialog: false,
    });
  };

  createSelect = (value, attr, label, items) => (
    <div className="form-group p-2">
      <p>{label}</p>
      <select
        className="form-control"
        value={value || ''}
        onChange={(e) => this.setValue(attr, e.target.value)}
      >
        {items.map((item) => (
          <option key={item.value} value={item.value}>{item.label}</option>
        ))}
      </select>
    </div>
  );

  userConfirmation = async (confirm) => {
    const { cancelType } = this.state;

    this.setState({ showUserModal: false });
    if (confirm && cancelType === 'order') this.cancelOrder();
    if (confirm && cancelType === 'load') this.cancelLoad();
  };

  showCancelOrder = (selectedOrder) => {
    this.setState({
      showCancelOrderModal: true,
      cancelType: 'order',
      selectedOrder,
    });
  };

  showCancelLoad = (selectedLoad) => {
    this.setState({
      showCancelLoadModal: true,
      cancelType: 'load',
      selectedLoad,
    });
  };

  cancelOrder = async () => {
    const { selectedOrder } = this.state;

    try {
      const result = await this.props.cancelOutboundOrder(selectedOrder.id);
      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE4523' /* Monitor de Carga */),
          I18n.t('BEE2948' /* Erro ao cancelar Documento de Saída */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE4523' /* Monitor de Carga */),
          I18n.t('BEE2949' /* Documento cancelado com sucesso! */),
          'top-right',
        );
        this.getOutboundLoads();
        this.getLoadOrders();
      }
    } catch (error) {
      const messageError = error.response
        && error.response.data && error.response.data.error && error.response.data.error.message;

      if (messageError) {
        addNotification(
          'danger',
          I18n.t('BEE4523' /* Monitor de Carga */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4523' /* Monitor de Carga */),
          I18n.t('BEE2950' /* Não foi possível cancelar o Documento de Saída. */),
          'top-right',
        );
      }
    }
    this.setState({ cancelType: '' });
  };

  cancelLoad = async () => {
    const { selectedLoad } = this.state;

    try {
      const result = await this.props.cancelOutboundLoad(selectedLoad.id);
      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE4523' /* Monitor de Carga */),
          I18n.t('BEE4557' /* Erro ao cancelar carga */),
          'top-right',
        );
      } else {
        addNotification(
          result.amountFail > 0 ? 'warning' : 'success',
          I18n.t('BEE4523' /* Monitor de Carga */),
          I18n.t(
            'BEE4563',
            { 0: result.amountTotal, 1: result.amountSuccess, 2: result.amountFail },
            /* Dos %{0} documentos selecionados, %{1} foram cancelados e %{2} não foram cancelados. */),
          'top-right',
        );
        this.getOutboundLoads();
        this.getLoadOrders();
      }
    } catch (error) {
      const messageError = error.response
        && error.response.data && error.response.data.error && error.response.data.error.message;

      if (messageError) {
        addNotification(
          'danger',
          I18n.t('BEE4523' /* Monitor de Carga */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4523' /* Monitor de Carga */),
          I18n.t('BEE4559' /* Não foi possível cancelar a carga. */),
          'top-right',
        );
      }
    }
    this.setState({ cancelType: '' });
  };

  render() {
    const {
      outboundLoads, loadOrders, selectedLoad,
      showLinkDockModal, showModalUrgent, showRemoveUrgent, showRemoveLinkedDockModal, showVerifyDockControl,
      showWarningFinalizeCheckVolumes, showPrintConsolidationDialog, showPrinterDialog, printerSelected, printerOptions,
      selectedDock, showCancelOrderModal, showCancelLoadModal,
    } = this.state;

    return (
      <>
        <Table
          breadcrumb={this.breadcrumb}
          headerTitle={I18n.t('BEE4523' /* Monitor de Carga */)}
          wikiHelp={ROUTES.OUTBOUND_LOAD_MONITOR_HELP}
          downloadCSV
          panelHeaderProps={{
            onClickReload: this.getOutboundLoads,
            children: I18n.t('BEE4526' /* Carga */).toUpperCase(),
          }}
          datePicker={{
            handleDateApplyEvent: this.handleDateApplyEvent,
          }}
          filterable
          expander
          data={outboundLoads}
          columns={this.tableColumns}
          defaultPageSize={5}
          defaultSorted={this.defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
            return false;
          }}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: async () => {
                  await this.setState({ selectedLoad: rowInfo.original });
                  await this.getLoadOrders();
                },
                style: {
                  background: selectedLoad && rowInfo.original.id === selectedLoad.id ? 'silver' : 'white',
                  cursor: 'pointer',
                },
              };
            }
            return {};
          }}
        />

        <Table
          downloadCSV
          panelHeaderProps={{
            children: I18n.t('BEE462' /* Documentos */).toUpperCase(),
          }}
          filterable
          expander
          data={loadOrders}
          columns={this.tableOrderColumns}
          defaultPageSize={5}
          defaultSorted={this.defaultSortedOrders}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
            return false;
          }}
        />

        {
          (showModalUrgent
            && (
              <SweetAlert
                info
                showCancel
                cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
                confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
                confirmBtnBsStyle="primary"
                cancelBtnBsStyle="default"
                title={I18n.t('BEE101' /* Você tem certeza? */)}
                onConfirm={() => this.modifyUrgency(true)}
                onCancel={() => this.closeUrgentModal()}
              >
                {I18n.t('BEE4529')}
                {/* A Carga selecionada será alterada para Urgente e terá prioridade no processo de Separação. */}
              </SweetAlert>
            )
          )
        }
        {
          showRemoveUrgent && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.modifyUrgency(false)}
              onCancel={() => this.closeUrgentModal()}
            >
              {I18n.t('BEE4528')}
              {/* A Carga selecionada terá sua Urgência removida e perderá sua prioridade no processo de Separação. */}
            </SweetAlert>
          )
        }
        {
          (showLinkDockModal && (
            <LoadLinkDockModal
              showLinkDockModal={showLinkDockModal}
              closeLinkDockModal={this.closeLinkDockModal}
              selectedLoad={selectedLoad}
              linkDock={this.linkDock}
              changeDock={this.changeDock}
              verifyDockControl={this.verifyDockControl}
            />
          ))
        }
        {
          (showRemoveLinkedDockModal
            && (
              <SweetAlert
                info
                showCancel
                cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
                confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
                confirmBtnBsStyle="primary"
                cancelBtnBsStyle="default"
                title={I18n.t('BEE101' /* Você tem certeza? */)}
                onConfirm={() => this.unlinkDock()}
                onCancel={() => this.closeRemoveLinkedDockModal()}
              >
                {I18n.t('BEE4537' /* Deseja realmente desvincular a doca desta carga? Ela será desvinculada também de todos os documentos vinculados. */)}
              </SweetAlert>
            )
          )
        }
        {(showVerifyDockControl
          && (
            <SweetAlert
              warning
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => {
                if (selectedLoad.status === 3) {
                  this.changeDock(selectedDock);
                } else {
                  this.linkDock(selectedDock);
                }
              }}
              onCancel={() => this.setState({ showVerifyDockControl: false })}
            >
              {I18n.t('BEE4542' /* Atenção: já existe uma carga atribuída a esta doca. Deseja vincular uma nova carga? */)}
            </SweetAlert>
          ))}
        {(showWarningFinalizeCheckVolumes
          && (
            <SweetAlert
              warning
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.finalizeCheckVolumes()}
              onCancel={() => this.setState({ showWarningFinalizeCheckVolumes: false })}
            >
              {I18n.t('BEE3374' /* O Controle de Doca será finalizado e o Romaneio será gerado! */)}
            </SweetAlert>
          )
        )}
        {(showPrinterDialog
          && (
            <SweetAlert
              confirmBtnText={I18n.t('BEE436' /* Selecionar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE1324' /* Selecionar Impressora */)}
              onConfirm={() => this.onSelectFilterModal()}
              onCancel={() => this.setState({
                showPrinterDialog: false,
              })}
            >
              <div className="mt-4">
                {this.createSelect(
                  printerSelected,
                  'printerSelected',
                  I18n.t('BEE328' /* Impressora */),
                  printerOptions,
                )}
              </div>
            </SweetAlert>
          )
        )}
        {(showPrintConsolidationDialog
          && (
            <SweetAlert
              warning
              showCancel
              cancelBtnText={I18n.t('BEE173' /* Não */)}
              confirmBtnText={I18n.t('BEE172' /* Sim */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE3375' /* Etiqueta de Consolidação */)}
              onConfirm={() => this.onDoPrintConsolidation()}
              onCancel={() => { this.setState({ showPrintConsolidationDialog: false }); }}
            >
              {
                I18n.t(
                  'BEE3373',
                  { 0: selectedLoad.totalVolumes || 0 },
                  /* Deseja imprimir as %{0} etiquetas de consolidação relacionadas aos documentos da doca? */
                )
              }
            </SweetAlert>
          )
        )}
        <UserConfirmationModal
          openModal={this.state.showUserModal}
          confirm={(confirm) => this.userConfirmation(confirm)}
        />
        {(showCancelOrderModal
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE2943' /* Cancelar Documento */)}
              onConfirm={() => this.setState({ showUserModal: true, showCancelOrderModal: false, cancelType: 'order' })}
              onCancel={() => this.setState({ showCancelOrderModal: false, cancelType: '' })}
            >
              {I18n.t('BEE2946' /* Documento de saída será cancelado! Deseja continuar? */)}
            </SweetAlert>
          )
        )}
        {(showCancelLoadModal
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE4555' /* Cancelar Carga */)}
              onConfirm={() => this.setState({ showUserModal: true, showCancelLoadModal: false, cancelType: 'load' })}
              onCancel={() => this.setState({ showCancelLoadModal: false, cancelType: '' })}
            >
              {I18n.t('BEE4556' /* A carga será cancelada. Isso também cancelará todos os documentos vinculados! Deseja continuar? */)}
            </SweetAlert>
          )
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app.userLogged && state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  getOutboundLoads: (
    filterStartDate,
    filterEndDate,
  ) => dispatch(getOutboundLoads(filterStartDate, filterEndDate)),
  getOutboundLoad: (outboundLoadId) => dispatch(getOutboundLoad(outboundLoadId)),
  getLoadOrders: (outboundLoadId) => dispatch(getLoadOrders(outboundLoadId)),
  toggleLoadPriority: (outboundLoadId, isUrgent) => dispatch(toggleLoadPriority(outboundLoadId, isUrgent)),
  linkDock: (outboundLoadId, dockCode) => dispatch(linkDock(outboundLoadId, dockCode)),
  unlinkDock: (outboundLoadId) => dispatch(unlinkDock(outboundLoadId)),
  changeDock: (outboundLoadId, dockCode) => dispatch(changeDock(outboundLoadId, dockCode)),
  verifyDockControl: (outboundLoadId, dockCode) => dispatch(verifyDockControl(outboundLoadId, dockCode)),
  finalizeCheckVolumes: (dockControlId) => dispatch(finalizeCheckVolumes(dockControlId)),
  printConsolidationsLabel: (printerCode, outboundOrderId, showLoading) => dispatch(
    printConsolidationsLabel(printerCode, outboundOrderId, showLoading),
  ),
  getUserPrinterOptions: () => dispatch(getUserPrinterOptions()),
  cancelOutboundOrder: (outboundOrderId) => dispatch(cancelOutboundOrder(outboundOrderId)),
  cancelOutboundLoad: (outboundLoadId) => dispatch(cancelOutboundLoad(outboundLoadId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutboundLoadMonitor));
